<template>
  <div class="bg-black font-redhat">
    <!-- <HeaderNav /> -->
    <main class="relative">
      <!-- Hero section -->
      <div
        class="min-h-screen flex items-center justify-center pb-[200px] xl:pb-[300px]"
      >
        <img class="lg:max-w-7xl" src="@/assets/an2.gif" alt="Leaf logo" />
      </div>
      <div class="flex flex-col items-center justify-center">
        <img
          src="@/assets/celebrating_white.svg"
          alt="Celebrating 40 years"
          class="w-[250px] mt-[-170px] sm:mt-[-300px] sm:w-[605px]"
        />
      </div>
      <!-- WELCOME -->
      <div
        class="w-full bg-contain bg-no-repeat bg-right bg-circle2 relative pb-24 lg:pb-[138px]"
      >
        <div class="mx-auto max-w-7xl px-6 lg:flex lg:px-8 text-left">
          <div class="mx-auto flex-shrink-0 lg:mx-0 lg:max-w-4xl lg:pt-8">
            <h1
              class="mt-10 text-3xl leading-snug md:text-4xl font-bold tracking-tight text-white lg:text-5xl flex flex-col"
            >
              <span class="sm:leading-[60px]">Welcome to DCUK FM, </span>
              <div class="sm:flex sm:gap-x-3 leading-[60px]">
                <div
                  class="flex flex-col lg:flex-row lg:w-full lg:items-center"
                >
                  <span class="whitespace-nowrap pr-3">the UK’s leading, </span>
                  <TextSlider class="-mt-3 lg:-mt-0"></TextSlider>
                </div>
              </div>
              <span class="sm:leading-[60px]">Specialists</span>
            </h1>
            <p
              class="pt-8 lg:pt-[64px] text-md sm:text-[32px] leading-snug text-[#8D8D8D]"
            >
              <span class="text-white">The one stop solution.</span>
              Traditionally recognised for our expertise in asbestos
              remediation, ventilation cleaning, and facilities management, we
              are innovatively expanding to enhance our services we offer. The
              new services we have introduced extend beyond showcasing our core
              strengths, covering an even wider breadth of expertise and further
              specialised services.
            </p>
          </div>
        </div>
      </div>

      <div class="relative isolate overflow-hidden lg:min-h-screen">
        <div class="mx-auto my-auto max-w-7xl">
          <div class="rounded-[40px] mx-6 lg:mx-0">
            <div class="mx-auto flex-shrink-0 lg:mx-0">
              <div class="flex justify-center">
                <img class="w-[700px]" :src="PuzzleSvg" alt="Leaf logo" />
              </div>
            </div>
          </div>
          <h2
            class="text-xl font-bold tracking-tight text-white sm:text-4xl pt-[50px] lg:pt-[153px] px-8 xl:px-0"
          >
            “The whole is greater than the sum of the parts”
          </h2>
          <p
            class="mx-auto max-w-4xl pt-[50px] text-xl sm:text-[32px] leading-tight text-[#8D8D8D] px-6 lg:px-8"
          >
            We remain firmly committed to ensuring unparalleled health, safety,
            and excellence in every new initiative we undertake. By consistently
            aiming to surpass industry standards, we consistently deliver
            high-quality solutions in every task we embark on.
          </p>
        </div>
      </div>

      <!-- SECTORS AND SERVICES -->
      <div
        class="mx-auto text-left bg-circle bg-center bg-auto bg-no-repeat mt-24 lg:mt-[267px]"
      >
        <div class="mx-auto max-w-7xl px-6 lg:px-0">
          <div
            class="mx-auto lg:mx-0 lg:max-w-7xl flex flex-col sm:flex-row justify-between gap-x-5"
          >
            <div
              class="text-center flex flex-col gap-y-5 sm:flex-row justify-center sm:items-center flex-3 w-full"
            >
              <h2
                class="text-left text-2xl md:text-3xl font-bold tracking-tight text-white lg:text-[48px] lg:leading-snug"
              >
                Sectors & Services
              </h2>
            </div>

            <div class="flex-3 w-full flex sm:justify-center items-center">
              <img :src="ArrowIcon" alt="Green Arrow" />
            </div>
            <p
              class="text-md sm:text-xl lg:text-[32px] lg:leading-normal text-white text-left pl-0"
            >
              Our mission is to provide clients with cost-effective solutions
              that minimise disruption whilst meeting all health and safety
              standards and environmental legislation requirements.
              <br class="sm:hidden" />
              <br class="sm:hidden" />
            </p>
          </div>
        </div>
        <!-- <SectorsCarousel
          class="mt-12 lg:mt-32 mx-6 lg:mx-0 xl:mx-auto xl:max-w-7xl"
        ></SectorsCarousel> -->
        <AppleCarousel
          class="mt-12 lg:mt-32 mx-6 lg:mx-0 xl:mx-auto xl:max-w-7xl"
        ></AppleCarousel>
      </div>

      <!-- CONTACT CARD -->

      <!-- Clients -->
      <div class="mx-auto max-w-7xl px-6 mt-24 lg:mt-[289px] lg:px-8">
        <h2 class="font-bold text-3xl lg:text-[50px] text-center">
          <span
            class="bg-gradient text-transparent bg-clip-text whitespace-nowrap"
            >Our values lead the way.<br />
          </span>
        </h2>
        <p
          class="pt-[35px] text-center text-md sm:text-3xl lg:text-[36px] lg:leading-normal font-semibold text-[#8D8D8D] tracking-wide"
        >
          We
          <span class="text-white">strive</span>
          to maintain a loyal client base by being highly
          <br class="hidden lg:block" />
          reputable and recommended within our industry.
        </p>
        <div class="mx-auto pt-[70px] lg:max-w-7xl">
          <ClientCarousel></ClientCarousel>
        </div>
      </div>

      <div class="mx-auto max-w-7xl px-6 lg:px-8 text-left pt-[94px]">
        <div class="mx-auto lg:mx-0">
          <div
            class="lg:divide-x gap-y-10 lg:divide-[#C0B7E854] w-full lg:bg-radial rounded-full grid grid-cols-1 lg:grid-cols-3 justify-between items-center p-5"
          >
            <div
              class="grid grid-cols-2 lg:flex gap-x-5 sm:pt-0 items-center justify-center w-full border-b border-gray lg:border-none pb-5 lg:pb-0"
            >
              <div class="flex items-center justify-center h-full">
                <img
                  class="w-[55px] h-[55px]"
                  :src="LocationIcon"
                  alt="Map Pin Icon"
                />
              </div>
              <div class="">
                <h3 class="text-md font-bold text-white">Pay Us a Visit</h3>
                <p class="text-sm text-white">
                  1 Woodfield Road, <br />
                  Welwyn Garden City <br />
                  AL7 1JQ
                </p>
              </div>
            </div>
            <div
              class="grid grid-cols-2 lg:flex gap-x-5 sm:pt-0 items-center justify-center w-full border-b border-gray lg:border-none pb-5 lg:pb-0 h-[105px]"
            >
              <div class="flex items-center justify-center h-full">
                <img
                  class="w-[44px] h-[44px]"
                  :src="PhoneIcon"
                  alt="Phone Icon"
                />
              </div>
              <div>
                <h3 class="text-md font-bold text-white">Give Us a Call</h3>
                <p class="text-sm text-white">
                  <a href="tel:03301245671">0330 124 5671</a>
                </p>
              </div>
            </div>
            <div
              class="grid grid-cols-2 lg:flex gap-x-5 sm:pt-0 items-center justify-center w-full"
            >
              <div class="flex items-center justify-center h-full">
                <img
                  class="w-[42px] h-[42px]"
                  :src="MailIcon"
                  alt="Mail Envelope Icon"
                />
              </div>
              <div>
                <h3 class="text-md font-bold text-white">Send Us a Message</h3>
                <p class="text-sm text-white">
                  <a href="mailto:info@dcukfm.com">info@dcukfm.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- HEALTH AND SAFETY -->
      <div
        class="w-full h-full bg-contain bg-no-repeat bg-right bg-circle3 pt-24 lg:pt-[300px]"
      >
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
          <div class="mx-auto lg:mx-0">
            <div
              class="mx-auto lg:mx-0 lg:max-w-7xl flex flex-col sm:flex-row justify-between gap-x-5"
            >
              <div class="text-center flex flex-3 w-1/2 flex-col">
                <h1
                  class="-mt-2 text-4xl font-bold tracking-tight text-white text-left lg:text-[64px] lg:leading-[84.67px] flex flex-col"
                >
                  <span class="whitespace-nowrap">No compromises </span>
                  <span class="whitespace-nowrap">
                    on
                    <span class="bg-gradient text-transparent bg-clip-text">
                      health
                    </span>
                    and
                  </span>
                  <span
                    class="bg-gradient text-transparent bg-clip-text sm:pb-4"
                    >safety</span
                  >
                </h1>
              </div>
              <div class="flex justify-start flex-3 w-full">
                <p
                  class="pt-6 lg:pt-0 text-md sm:text-xl lg:text-[24px] lg:leading-normal leading-normal text-white text-left pl-0 sm:pl-6"
                >
                  We are committed to protecting the environment, the health and
                  safety of our employees, customers and the communities where
                  we operate. <br />
                  <br />
                  Find out the ways we keep our promise and keep you safe.
                  <br />
                  <br />
                  <a
                    href="/health-safety"
                    class="mb-5 mt-5 lg:mt-[55px] lg:w-[193px] flex items-center justify-center gap-x-5 ring-1 ring-white rounded-[20px] px-3 py-2 text-white text-sm lg:text-[20px]"
                  >
                    <span>Learn more</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-5 h-5"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M8.25 4.5l7.5 7.5-7.5 7.5"
                      />
                    </svg>
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div class="mx-auto pt-[70px]">
            <AccreditationsCarousel></AccreditationsCarousel>
          </div>
        </div>
      </div>

      <!-- Global -->
      <div class="mt-24 lg:mt-[365px] bg-[#D9D9D9]">
        <div class="mx-auto max-w-7xl px-6 lg:flex lg:px-8 text-left">
          <div class="mx-auto flex-shrink-0 lg:mx-0 lg:max-w-4xl">
            <h2
              class="text-2xl md:text-4xl font-bold tracking-tight text-[#1D1D1D] lg:text-5xl pt-12 lg:pt-[76px] flex flex-col"
            >
              We are Global
            </h2>
            <p
              class="mt-6 text-md sm:text-xl lg:text-[32px] lg:leading-snug text-[#777777]"
            >
              <span class="text-[#1D1D1D]"> DCUK can mobilise</span>
              to cover different territories, meeting the legislation required
              in that country. We have dedicated site teams that are BOSIET
              trained for working off-shore.
            </p>
          </div>
        </div>
        <div class="overflow-hidden">
          <div class="mx-auto w-full -mt-[45px] lg:-mt-[150px]">
            <img
              src="../assets/DCUK_containersWEB.webp"
              alt="App screenshot"
              class=""
            />
          </div>
        </div>
      </div>
      <div class="mx-auto mt-8 max-w-7xl px-6 sm:mt-20 md:mt-24 lg:px-8">
        <ul
          class="flex gap-x-4 lg:gap-x-8 gap-y-4 items-center justify-center flex-row flex-wrap"
        >
          <li
            v-for="country in countries"
            :key="country"
            class="font-semibold text-white text-sm lg:text-[20px] flex items-center gap-x-4 lg:gap-x-8"
          >
            {{ country }}
            <svg
              v-if="country != 'Nigeria'"
              class="h-1.5 w-1.5 fill-white"
              viewBox="0 0 6 6"
              aria-hidden="true"
            >
              <circle cx="3" cy="3" r="3" />
            </svg>
            <svg
              v-if="country === 'Nigeria'"
              class="h-1.5 w-1.5 fill-white hidden sm:block"
              viewBox="0 0 6 6"
              aria-hidden="true"
            >
              <circle cx="3" cy="3" r="3" />
            </svg>
          </li>
          <li
            class="gap-x-4 font-semibold text-white text-sm sm:text-sm lg:text-[20px] items-center lg:list-disc flex"
          >
            United Kingdom
          </li>
        </ul>
      </div>

      <!-- COMMUNITY -->
      <div
        class="w-full h-full bg-contain bg-no-repeat bg-right bg-circle4 pt-24 lg:pt-[400px] pb-24 lg:pb-[254px] px-6"
      >
        <div class="mx-auto max-w-7xl">
          <div class="mx-auto lg:mx-0">
            <div
              class="mx-auto lg:mx-0 lg:max-w-7xl lg:pt-8 flex flex-col items-start sm:flex-row justify-between gap-x-5"
            >
              <div class="text-left flex flex-3 w-full flex-col">
                <h1
                  class="-mt-2 text-4xl leading-none md:text-3xl font-bold text-white text-left lg:text-[55px] lg:leading-[72.77px]"
                >
                  <span>
                    <span class="bg-gradient text-transparent bg-clip-text"
                      >Community
                    </span>
                    is the
                    <br />
                  </span>
                  <span class="">core of our culture. </span>
                </h1>
                <a
                  href="/equal-opportunities"
                  class="mb-5 mt-5 lg:mt-[55px] lg:w-[193px] flex items-center justify-center gap-x-5 ring-1 ring-white rounded-[20px] px-3 py-2 text-white text-sm lg:text-[20px]"
                >
                  <span>Learn more</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-5 h-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M8.25 4.5l7.5 7.5-7.5 7.5"
                    />
                  </svg>
                </a>
              </div>
              <div class="flex justify-start w-full lg:-mt-3">
                <p
                  class="text-md sm:text-xl lg:text-[36px] lg:leading-snug text-[#8D8D8D] text-left pl-0 sm:pl-6"
                >
                  We build an inclusive culture rooted in community at DCUK. A
                  place where everyone feels supported, valued, connected, and
                  empowered to do their best work. Because we know we are better
                  at what we do when we are free to be who we are.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Stats -->
      <div
        class="mx-auto max-w-7xl sm:bg-circle5 bg-contain bg-no-repeat bg-center"
      >
        <div class="mx-auto lg:mx-0 lg:max-w-7xl">
          <p
            class="flex flex-col gap-y-2 mt-2 text-3xl font-bold text-white sm:text-4xl lg:text-[48px] text-left pl-6"
          >
            <span>Numbers tell</span>
            <span>our story</span>
          </p>
        </div>
        <dl
          class="lg:divide-x divide-[#EDEDED] mx-auto mt-10 lg:mt-16 grid grid-cols-1 gap-x-8 gap-y-10 text-white sm:mt-20 sm:grid-cols-2 sm:gap-y-16 lg:mx-0 lg:max-w-7xl lg:grid-cols-3"
        >
          <div
            v-for="stat in stats"
            :key="stat.id"
            class="flex flex-col gap-y-3 px-6 lg:pl-10"
          >
            <dt
              class="text-sm lg:text-[16px] leading-6 text-left text-[#A1A1AA] lg:pt-6"
            >
              {{ stat.name }}
            </dt>

            <dd
              class="text-left order-first text-4xl tracking-tight lg:text-[65px] font-bold"
            >
              {{ stat.value }}
            </dd>
          </div>
        </dl>
        <div
          class="mt-24 lg:mt-32 text-center flex items-center justify-center md:px-32 px-6 lg:px-48 text-[#8D8D8D] text-sm sm:text-lg lg:text-[24px] lg:leading-snug"
        >
          <p>
            Our investment and staff training over the years has enabled us to
            set the high standards demanded by the industry. Without this
            support and commitment by our employees and our standards, we would
            not be recognised as an Industry Leader.
          </p>
        </div>
        <div class="flex flex-col items-center justify-center">
          <a
            href="/equal-opportunities"
            class="mb-5 mt-5 lg:mt-[55px] lg:w-[193px] flex items-center justify-center gap-x-5 ring-1 ring-white rounded-[20px] px-3 py-2 text-white text-sm lg:text-[20px]"
          >
            <span>Learn more</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-5 h-5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M8.25 4.5l7.5 7.5-7.5 7.5"
              />
            </svg>
          </a>
        </div>
      </div>

      <div
        class="rounded-[40px] mx-6 lg:mx-auto mt-24 lg:mt-[150px] max-w-7xl flex flex-col items-center justify-center"
      >
        <div class="mx-auto flex-shrink-0 lg:mx-0">
          <div class="flex justify-center">
            <img
              class="w-[700px]"
              src="@/assets/carbon-neutral.svg"
              alt="Leaf logo"
            />
          </div>
        </div>
        <div class="mx-auto flex items-center justify-center">
          <a
            href="/sustainability"
            class="mb-5 mt-5 lg:mt-[62px] flex items-center justify-center gap-x-5 ring-1 ring-white rounded-[20px] px-5 py-2 text-white text-xs lg:text-[20px]"
          >
            <span class="whitespace-nowrap">Learn more about DCUK 2030</span>
            <img src="@/assets/sustain-icon.png " alt="" />
          </a>
        </div>
      </div>

      <div
        class="mx-auto px-6 lg:px-0 flex items-center justify-center max-w-7xl"
      >
        <div
          class="rounded-xl xl:rounded-[30px] lg:mx-0 mt-24 lg:mt-[150px] bg-spBanner bg-cover bg-no-repeat aspect-[1280/508] w-full flex justify-between"
        >
          <div class="flex items-end justify-between gap-x-8">
            <a
              href="/technology#spaceplus"
              class="xl:ml-[63px] xl:mb-[50px] mb-3 ml-5 lg:mt-[55px] lg:w-[193px] flex items-center justify-center gap-x-5 ring-1 ring-white rounded-[20px] px-2 py-1 lg:px-3 lg:py-2 text-white text-xs sm:text-sm lg:text-[20px]"
            >
              <span class="whitespace-nowrap">Learn more</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-5 h-5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M8.25 4.5l7.5 7.5-7.5 7.5"
                />
              </svg>
            </a>
          </div>

          <div class="flex items-end ml-3 mr-1 pt-[30px] xl:pt-[38px]">
            <img
              src="@/assets/SpacePLUS-Banner-Image.webp"
              alt=""
              class="h-full xl:max-h-[477px]"
            />
          </div>
        </div>
      </div>

      <!-- Blog Section -->
      <div
        class="w-full h-full bg-contain bg-top sm:bg-circle5 pt-24 lg:pt-[162px]"
      >
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
          <div class="mx-auto lg:mx-0 lg:max-w-7xl">
            <div class="text-left flex flex-3 w-1/2 flex-col">
              <h1
                class="text-4xl font-bold tracking-tight text-white text-left lg:text-[48px]"
              >
                Our blog
              </h1>
              <p class="text-white pt-5 lg:text-[24px]">
                Like to read? <br />
                Check out our blog
              </p>
              <img class="w-[228px]" :src="ArrowIcon" alt="Green Arrow" />
            </div>
          </div>
          <div
            class="box bg-[#000000B2] [border-image:linear-gradient(90deg,#2075bc_0%,#01a79d_34.41%,#82c77c_68.83%,#fcee23_103.24%)_1] bg-clip-border border mx-auto lg:mx-0 lg:max-w-7xl gradring rounded-md flex flex-col sm:flex-row items-center justify-center divide-y sm:divide-y-0 divide-x-0 sm:divide-x divide-[#86868B]"
          >
            <div
              v-for="item in blog"
              :key="item.title"
              class="p-10 flex flex-col items-center justify-center"
            >
              <img
                class="object-cover h-48 w-96"
                :src="`https://stingray-app-qsr9b.ondigitalocean.app/static/images/${item.image}`"
                alt=""
              />
              <div class="flex flex-col items-center justify-center pt-6 h-48">
                <h2 class="text-white text-2xl text-left">{{ item.title }}</h2>
                <p class="text-sm text-left text-gray pt-2">
                  {{ item.subtitle }}
                </p>
              </div>
              <div class="text-left text-sm pt-5 w-full">
                <a
                  class="text-white pt-2 pb-1 border-b [border-image:linear-gradient(to_right,#2075BC,#01A79D,#82C77C,#FCEE23)_1_0%]"
                  href="/blog"
                  >Read the Story</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <h2
        class="mt-24 lg:mt-[289px] text-center text-xl md:text-2xl lg:text-[36px] text-white px-6 lg:px-8"
      >
        <span class="font-bold">Sustainable Critical Services.</span>
        The preferred choice.
      </h2>
      <!-- FOOTER -->
      <LogoFoot class="pt-24 lg:pt-[295px] lg:-mt-[150px]"></LogoFoot>
    </main>
  </div>
</template>

<script>
// import TestCarousel from "./reusable/TestCarousel.vue";
// import SectorsCarousel from "./reusable/SectorsCarousel.vue";
import AppleCarousel from "./carousel/AppleCarousel.vue";
import LeafLogo from "@/assets/logo.svg";
import PuzzleSvg from "@/assets/puzzle.webp";
import ArrowIcon from "@/assets/arrow.svg";
import LocationIcon from "@/assets/icons/location.svg";
import PhoneIcon from "@/assets/icons/phone.svg";
import MailIcon from "@/assets/icons/mail.svg";
import LogoFoot from "./reusable/LogoFoot.vue";
import ClientCarousel from "./reusable/ClientCarousel.vue";
import AccreditationsCarousel from "./reusable/AccreditationsCarousel.vue";
import TextSlider from "./reusable/TextSlider.vue";

export default {
  data() {
    return {
      LeafLogo,
      ArrowIcon,
      LocationIcon,
      PhoneIcon,
      MailIcon,
      LogoFoot,
      PuzzleSvg,
      stats: [
        {
          id: 1,
          name: "Non-Licence jobs in the last Financial Year 22/23",
          value: "5,261",
        },
        {
          id: 2,
          name: "Asbestos notifiable jobs within the latest licence period. ",
          value: "473",
        },
        {
          id: 3,
          name: "Linear metres of ductwork cleaned in the last 5 years, as of 2023.",
          value: "75,000",
        },
        {
          id: 4,
          name: "Tender Win Rate. The foundation to our success is our tender win ratio.",
          value: "63%",
        },
        {
          id: 5,
          name: "Annual Average to November 2023. Measuring accidents and trends across the company.",
          value: "0.15 AFR",
        },
        {
          id: 6,
          name: "Fire Dampers inspected in the last 4 years, as of 2023.",
          value: "68,351",
        },
      ],
      countries: [
        "Spain",
        "Germany",
        "Iceland",
        "Nigeria",
        "Singapore",
        "Falkland Islands",
      ],
      blog: [],
      textList: [
        "Ventilation Hygiene",
        "Ductwork Cleaning",
        "Asbestos Remediation",
      ],
      currentIndex: 0,
    };
  },
  methods: {
    getBlogs() {
      this.axios
        .get("https://stingray-app-qsr9b.ondigitalocean.app/get_blogs")
        .then((response) => {
          this.blog = response.data.slice(0, 3);
        });
    },
  },

  computed: {},
  components: {
    // TestCarousel,
    LogoFoot,
    ClientCarousel,
    AccreditationsCarousel,
    // SectorsCarousel,
    TextSlider,
    AppleCarousel,
  },
  mounted() {
    this.getBlogs();
  },
};
</script>
